<template>
  <div class="paging-nav page" v-if="pages > 0">
    <ul class="pagelist">
      <li class="total-page">共{{pages}}页</li>
      <li class="jump" :class="{'disable': pstart}" @click="!pstart && inOrderToJump('prev')"><span>&lt;</span></li>
      <li class="jump" v-show="currentPage > 5" @click="jumpPage(1)"><span>1</span></li>
      <li class="ellipsis" v-show="efont"><strong>...</strong></li>
      <li class="jump" v-for="num in indexs" :key="num" :class="{bgprimary: currentPage==num}" @click="jumpPage(num)">
        <span>{{num}}</span>
      </li>
      <li class="ellipsis"  v-show="ebehind"><strong>...</strong></li>
      <li v-show="currentPage < pages - 4" class="jump" @click="jumpPage(pages)"><span>{{pages}}</span></li>
      <li :class="{'disabled': pend}" class="jump" @click="!pend && inOrderToJump('next')"><span>&gt;</span></li>
      <li class="jumppoint">前往</li>
      <li class="jumpinp"><input type="text" v-model="jumpToPage"><em>页</em></li>
      <li class="jump gobtn" @click="jumpToPage > 0 ? jumpPage(jumpToPage,'inputJump') : popHint()">确定</li>
    </ul>
  </div>
</template>
<script>
/*
 * 需要参数：:sumTotal（传入的列表总数）:pageLimit(每页显示的条数)
 *          :sumPages(传入的页总数，存在就默认选中)
 * 获取当前导航信息： 
 *    @jumpByCurrentPage(
 *       'currentPage':当前页
 *       'jumpToPage':输入指定跳转页（不输入该属性不存在）
 *    )
 * 
 * 提供方法：
 * jumpFirstPage ：跳转到第一页
 * jumpLastPage ：跳转到最后一页
 *                
 */

export default {
  name: 'public_paging_nav',
  props: {
    'sumTotal':[String,Number],
    'pageLimit':[String,Number],
    'sumPages':[String,Number]
  },
  data () {
    return {
      contentlimit:10,
      currentPage: 1, //当前页
      pages: 0, //总页数
      jumpToPage: '', //跳转页
    }
  },
  mounted() {
    this.setPages();
  },
  computed: {
    show: function() {
      return this.pages && this.pages != 1;
    },
    pstart: function() {
      return 1 == this.currentPage;
    },
    pend: function() {
      return this.pages == this.currentPage;
    },
    efont: function() {
      if (this.pages <= 5) {
        return false;
      }
      return this.currentPage > 5;
    },
    ebehind: function() {
      if (this.pages <= 5) {
        return false;
      }

      var nowAy = this.indexs; 
      return nowAy[nowAy.length - 1] != this.pages;
     },
    indexs: function() {
      var  left = 1, right = this.pages, arr = [];
      
      if (this.pages >= 7) {
        if (this.currentPage > 5 && this.currentPage < this.pages - 4) {
          left = Number(this.currentPage) - 3; 
          right = Number(this.currentPage) + 3;
        } else {
          if (this.currentPage <= 5) {
            left = 1; 
            right = 7;
          } else {
            right = this.pages;
            left = this.pages - 6;
          }
        }
      }
      while (left <= right) {
        arr.push(left);
        left ++;
      }
      return arr;
    }
  },
  methods: {
    setPages: function() {
      if (this.sumPages) {
        this.pages = this.sumPages;
      } else {
        this.pages = Math.ceil(this.sumTotal / this.pageLimit);
      }
    },
    jumpPage: function(pageIndex,jumpType) {
      this.currentPage = pageIndex;

      let jumpMsg = {
        'currentPage':this.currentPage
      }

      if (jumpType) {
        jumpMsg.jumpToPage = parseInt(this.jumpToPage);
      } else {
        this.jumpToPage = '';
      }

      this.$emit('jumpByCurrentPage',jumpMsg);
    },
    inOrderToJump: function(jumpType) {
      if (jumpType == 'prev') {
        this.currentPage -= 1;
      } else {
        this.currentPage += 1;
      }

      this.currentPage = this.controlCurrentPageScope(this.currentPage);
      this.jumpPage(this.currentPage);
    },
    controlCurrentPageScope: function(pageNum) {
      let totalPages = this.pages;
      let controlPageNum = pageNum;
    
      if (controlPageNum <= 1) {
        controlPageNum = 1;
      } else if (controlPageNum >= totalPages) {
        controlPageNum = totalPages;
      }

      return controlPageNum;
    },
    jumpFirstPage: function() {
      this.currentPage = 1;
      this.jumpPage(this.currentPage);
    },
    jumpLastPage: function() {
      this.currentPage = this.pages;
      this.jumpPage(this.currentPage);
    },
    popHint: function() {
     this.$elementMsg.error({
      'message': '请输入跳转页码',
      'showClose':true,
      'customClass': 'pop-class-error',
      'duration': 3000
    })
    }
  },
  watch: {
    sumTotal: function(){
      this.setPages();
    },
    currentPage: function() {
      this.currentPage = this.controlCurrentPageScope(this.currentPage);
    },
    jumpToPage: function() {
      var iptJumpPage = this.jumpToPage;
      if (iptJumpPage) {
        this.jumpToPage = this.controlCurrentPageScope(this.jumpToPage);
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .paging-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    .pagelist {
      display: flex;
      justify-content: center;
      align-items: center;
      &>li {
        &>span {
          display: block;
          width: 34px;
          height: 34px;
          font-size: 14px;
          text-align: center;
          line-height: 34px;
          margin-right: 8px;
          border: 1px solid #dedede;
          border-radius: 4px;
          cursor: pointer;
          color: #555;
        }
        &>strong {
          display: inline;
          margin-right: 8px;
          color: #555;
        }
      }
      &>li.bgprimary {
        span {
          background: #ff7800;
          border: 1px solid #ff7800;
          color: #fff;
        }
      }
      &>li:hover {
        &>span {
          background: #ff7800;
          border: 1px solid #ff7800;
          color: #fff;
        }
      }
      &>li.disable, &>li.disabled {
        &>span {
          background: #efefef;
          border: 1px solid #dedede;
          cursor: default;
          color: #dedede;
        }
      }
      .total-page, 
      .jumppoint,
      .jumpinp,
      .gobtn {
        font-size: 14px;
        color: #555;
      }
      .total-page {
        margin-right: 21px;
      }
      .jumppoint {
        margin-left: 11px;
        margin-right: 9px;
      }
      .jumpinp {
        display: flex;
        align-items: center;
        input {
          display: block;
          width: 34px;
          height: 34px;
          text-align: center;
          line-height: 34px;
          border-radius: 4px;
          border: 1px solid #dedede;
          color: #555;
        }
        &>em {
          display: block;
          font-size: 14px;
          font-style: normal;
          margin-left: 7px;
        }
      }
      .gobtn {
        margin-left: 16px;
        cursor: pointer;
        color: #ff7800;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/public_paging_nav.vue